import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { PaymentLinkRow } from '@woovi/ui';

import type { PaymentLinkActivePixCreditCard_charge$key } from './__generated__/PaymentLinkActivePixCreditCard_charge.graphql.ts';
import { useChargePaymentMethod } from '../../../charge/useChargePaymentMethod.tsx';

import type { ReactNode } from 'react';

type PaymentLinkActivePixCreditCardProps = {
  charge: PaymentLinkActivePixCreditCard_charge$key;
};
const PaymentLinkActivePixCreditCard = (
  props: PaymentLinkActivePixCreditCardProps,
): ReactNode => {
  const { t } = useTranslation();
  const charge = useFragment<PaymentLinkActivePixCreditCard_charge$key>(
    graphql`
      fragment PaymentLinkActivePixCreditCard_charge on Charge {
        value
        valueWithDiscount
        ...useChargePaymentMethod_charge
      }
    `,
    props.charge,
  );

  const { isPixCreditCard, pixCob, creditCard } =
    useChargePaymentMethod(charge);

  if (!isPixCreditCard) {
    return null;
  }

  const valueTotal = charge?.value ?? charge?.valueWithDiscount;

  if (!creditCard || !creditCard?.method) {
    return (
      <Stack spacing={2} sx={{ mt: '40px' }}>
        <PaymentLinkRow title={t('Pix in Cash')} value={pixCob.value} />
        <Divider />

        <PaymentLinkRow title={t('Total')} value={valueTotal} />
      </Stack>
    );
  }

  return (
    <Stack spacing={2} sx={{ mt: '40px' }}>
      <PaymentLinkRow title={t('Pix entrance')} value={pixCob.value} />
      <PaymentLinkRow
        title={`+${creditCard.installmentNumber}x ${t('in installments')}`}
        value={creditCard.value}
      />
      <Divider />

      <PaymentLinkRow title={t('Total')} value={valueTotal} />
    </Stack>
  );
};

export default PaymentLinkActivePixCreditCard;
